<template>
  <div class="sn-f-b-s report-detail">
    <sn-navigator id="BGCX" :initial="perpetual.FUNCTION_ID_TJBG"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s report-detail-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_TJBG),
        replace: true,
        router: '/physical/report'
      }, {
        title: `${$sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_TJBG)}详情`
      }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 detail-blank">
        <template v-if="!$sn.validate.empty(physicalReportDetailInfo)">
          <div class="sn-f-c-c detail-title">{{$sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_TJBG)}}</div>
          <div class="detail-head">
            <div class="sn-f-b-c">
              <div class="sn-f-s-c">
                <div v-if="physicalReportDetailInfo.patName">姓名：{{physicalReportDetailInfo.patName}}</div>
                <div class="margin-left-10" v-if="physicalReportDetailInfo.patSex">性别：{{physicalReportDetailInfo.patSex}}</div>
                <div class="margin-left-10" v-if="physicalReportDetailInfo.patAge">年龄：{{physicalReportDetailInfo.patAge}}</div>
                <div class="margin-left-10" v-if="physicalReportDetailInfo.checkDate">体检日期：{{$sn.format.date(new Date(physicalReportDetailInfo.checkDate), 'yyyy年MM月dd日')}}</div>
                <div class="margin-left-10" v-if="physicalReportDetailInfo.totCheckDoc">总检医生：{{physicalReportDetailInfo.totCheckDoc}}</div>
              </div>
            </div>
            <div class="margin-top-10" v-if="physicalReportDetailInfo.reqNo">体检单号：{{physicalReportDetailInfo.reqNo}}</div>
          </div>
          <div class="sn-f-c-c suggestion-summary">
            <div class="sn-f-c-c blank left-blank" :class="{'right-blank': tab.label === 'details', 'select-blank': currentLabel === tab.label}" v-for="tab in tabArray" :key="tab.label" @click="currentLabel = tab.label">
              {{tab.text}}
            </div>
          </div>
          <!-- 综述建议 -->
          <div class="scroll-region">
            <div class="summary-line" v-if="currentLabel === 'summary'">
              <div class="row">
                <div class="sn-f-b-c proposal-title">
                  <div class="sn-fs-16 sn-fw-bold">综述建议</div>
                  <div class="sn-fs-16 sn-fw-bold" v-if="physicalReportDetailInfo.totCheckDoc">总检医生：{{physicalReportDetailInfo.totCheckDoc}}</div>
                </div>
                <div class="proposal-row">
                  <div class="row-title">体检结论</div>
                  <div class="row-text">{{physicalReportDetailInfo.summary || '无'}}</div>
                </div>
                <div class="proposal-row">
                  <div class="row-title">体检建议</div>
                  <div class="row-text">{{physicalReportDetailInfo.suggestion || '无'}}</div>
                </div>
              </div>
            </div>
            <div class="details-line" v-else>
              <template v-if="physicalReportDetailInfo.list && $sn.validate.array(physicalReportDetailInfo.list) && physicalReportDetailInfo.list.length > 0">
                <div class="single-box" v-for="(item, index) in physicalReportDetailInfo.list" :key="index">
                  <div class="sn-f-s-c single-title">体检类别名称：{{item.itemName}} <div class="sn-ph-20">体检科室：{{item.deptName}}</div></div>
                  <div class="sn-table">
                    <table>
                      <thead>
                        <tr>
                          <th v-for="result in getFormat(item.itemType)" :key="result.key">{{result.label}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(detail, detailIndex) in item.reportList" :key="detailIndex">
                          <td v-for="result in getFormat(item.itemType)" :key="result.key">
                            {{detail[result.key]}}
                            <template v-if="result.key === 'examItemResult'">
                              <span v-if="detail.examItemFlag === '2'" class="sn-fc-red1 iconfont icon-xiangshang"></span>
                              <span v-if="detail.examItemFlag === '1'" class="sn-fc-red1 iconfont icon-paixu"></span>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </template>
              <template v-else><sn-no-data></sn-no-data></template>
            </div>
          </div>
        </template>
        <template v-else><sn-no-data></sn-no-data></template>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';

export default {
  data() {
    return {
      perpetual: Constants,
      physicalReportDetailInfo: {},
      tabArray: [{ label: 'summary', text: '综述建议' }, { label: 'details', text: '体检详情' }],
      currentLabel: 'summary' // summary: 综述建议 details: 详情
    };
  },
  computed: {},
  watch: {},
  created: function() {
    document.title = `${this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_TJBG)}详情`;
    this.$route.meta.title = `${this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_TJBG)}详情`;
    if (this.$sn.utils.getHospitalSessionStorage('PhysicalReport_Info') && this.$sn.utils.getHospitalSessionStorage('PhysicalReport_Info').reqNo) {
      this.queryPhysicalReportInfo(this.$sn.utils.getHospitalSessionStorage('PhysicalReport_Info').reqNo);
    }
  },
  methods: {
    // 格式化
    getFormat(itemType) {
      const result = {
        '1': [
          { key: 'examItem', label: '项目名称' },
          { key: 'examItemResult', label: '结果&结论' },
          ...(this.exist('examItemUnit') ? [{ key: 'examItemUnit', label: '单位' }] : []),
          { key: 'examItemRange', label: '参考范围' }
        ],
        '2': [
          { key: 'description', label: '检查所见' },
          { key: 'impression', label: '印象建议' }
        ],
        '3': [
          { key: 'examItem', label: '项目名称' },
          { key: 'examItemResult', label: '结果&结论' }
        ]
      };
      return result[itemType] || [];
    },
    // 是否有数据
    exist(key) {
      let verify = false;
      if (this.physicalReportDetailInfo.list.length > 0) {
        this.physicalReportDetailInfo.list.forEach(item => {
          item.reportList.forEach(el => {
            if (!this.$sn.validate.empty(el[key])) verify = true;
          });
        });
      }
      return verify;
    },
    // 体检详情
    queryPhysicalReportInfo(reqNo) {
      this.physicalReportDetailInfo = {};
      const params = {
        url: this.$sn.format.caption(Swagger.getPhysicalReportInfo, [this.$sn.utils.getHospitalId()]),
        query: {
          reqNo: reqNo
        },
        header: true
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0) {
          if (result.data) this.physicalReportDetailInfo = result.data;
        }
        else this.$sn.assembly.toast({ caption: result?.msg || Messages.C001 });
      });
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.report-detail {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: $white;
  left: 0;
  top: 0;

  &-region {
    overflow: hidden;
    height: 100%;

    .detail-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding: 20px 10% 0;
      display: flex;
      flex-direction: column;

      .detail-title {
        font-size: 20px;
        margin-bottom: 20px;
        font-weight: bold;
      }

      .detail-head {
        font-size: 16px;
        margin-bottom: 10px;
        border-bottom: 1px solid $border1;
        padding-bottom: 10px;

        .margin-top-10 {
          margin-top: 10px;
        }

        .margin-left-10 {
          margin-left: 10px;
        }
      }

      .suggestion-summary {
        margin-top: 10px;
        background-color: $white;

        .blank {
          font-size: 18px;
          width: 20%;
          height: 50px;
          border-radius: 10px 0 0 10px;
          background-color: $white;
          border: 2px solid $main;
          color: $main;
        }

        .right-blank {
          border-radius: 0 10px 10px 0;
        }

        .select-blank {
          background-color: $main;
          border: none;
          color: $white;
        }
      }

      .scroll-region {
        margin-top: 20px;
        flex: 1;
        overflow-y: auto;
        padding-bottom: 20px;

        .summary-line {
          padding: 0 0 24px;

          .row {
            border: 2px solid $border1;

            .proposal-title {
              background-color: $border1;
              height: 40px;
              padding: 0 24px;
            }

            .proposal-row {
              margin: 0 24px;
              border-bottom: 2px dashed $border1;
              padding-top: 10px;

              .row-title {
                font-size: 14px;
                font-weight: bold;
                color: $main;
              }

              .row-text {
                font-size: 14px;
                padding: 10px 0;
              }

              &:last-child {
                border-bottom: 0;
              }
            }
          }
        }

        .details-line {
          .single-box {
            margin-top: 20px;

            .single-title {
              margin-bottom: 20px;

              .sn-ph-20 {
                padding: 0 20px;
              }
            }

            .sn-table {
              table {
                table-layout: fixed;
              }

              thead {
                background-color: $background1;

                th {
                  color: $text1;
                  border-right: 1px solid $white;
                  border-radius: 0;

                  &:last-child {
                    border-right: 1px solid $border1;
                  }
                }
              }

              th,
              td {
                @include fs(14);

                height: auto;
                min-height: 30px;
                color: $text1;
              }

              td {
                padding: 10px;
              }
            }

            &:first-child {
              margin-top: 0;
            }
          }
        }
      }
    }
  }
}
</style>
